module.exports = __webpack_public_path__ + "img/NAVIGATION.dd1326ed.svg";